@if (profileField$ | async; as profileField) {
  <dt [id]="profileField.FieldDefinition.DottedKey" class="sh-description-list__term sh-complex-title" [style]="nestedPadding$ | async">
    <sh-field-label [label]="profileField.DisplayLabel" [labelIcons]="labelIcons"></sh-field-label>
  </dt>
  <dd class="sh-description-list__details"></dd>
  @for (record of flattenedComplexListFieldRecords; track record; let recordIndex = $index) {
    <dt [id]="profileField.FieldDefinition.FlatKey" class="sh-description-list__term" [ngStyle]="nestedPadding$ | async">
      <i>{{ childDefinitionLabel$ | async }} {{ recordIndex + 1 }}</i>
    </dt>
    <dd class="sh-description-list__details"></dd>
    @for (grandChildProfileField of grandChildProfileFields$ | async; track grandChildProfileField) {
      @if (grandChildProfileField.FieldDefinition) {
        <sh-generic-readonly-field
          [style]="nestedPadding$ | async"
          [profileField]="grandChildProfileField"
          [record]="record"
          [nestedIndex]="(nestedIndex$ | async)! + 1"
          >
        </sh-generic-readonly-field>
      } @else {
        <dt class="sh-description-list__term" [style]="nestedPadding$ | async">{{ grandChildProfileField.DisplayLabel }}</dt>
        <dd class="sh-description-list__details">
          {{ "form.error.fielddefinition-not-found" | translate: { id: grandChildProfileField.FieldDefinitionId } }}
        </dd>
      }
    }
  }
  <dt class="sh-description-list__term"></dt>
  <dd class="sh-description-list__details sh-complex-spacer"></dd>
}
